import { DEFAULT_BORDER_RADIUS } from "constants/borders";

const baseStyles = {
  borderRadius: DEFAULT_BORDER_RADIUS,
  border: "1px solid",
  fontStyle: "normal",
};

const extendedStyles = {
  ...baseStyles,
  fontWeight: "normal",
  borderColor: "highlight.600",
};
const Button = {
  sizes: {
    sm: {
      fontSize: "sm",
      px: "24px",
      py: "7px",
    },
    smicon: {
      fontSize: "sm",
      pr: "10px",
      pl: "24px",
      py: "7px",
    },
    md: {
      fontSize: "lg",
      px: "47px",
      py: "12px",
    },

  },
  variants: {
    primary: {
      ...extendedStyles,
      bg: "highlight.600",
      textColor: "body.100",
      _hover: {
        bg: "highlight.700",
        borderColor: "highlight.700",
        _disabled: { bg: "body.500", borderColor: "body.500" },
      },
      _active: { bg: "highlight.700", borderColor: "highlight.700" },
      _focus: { bg: "highlight.700", borderColor: "highlight.700" },
      _disabled: { bg: "body.500", borderColor: "body.500" },
    },
    secondary: {
      ...extendedStyles,
      bg: "transparent",
      textColor: "highlight.600",
      _hover: {
        bg: "highlight.100",
        borderColor: "highlight.600",
        textColor: "highlight.600",
        _disabled: { borderColor: "body.500", textColor: "body.500", bg: "transparent" },
      },
      _active: { borderColor: "highlight.700", textColor: "highlight.700" },
      _focus: { borderColor: "highlight.700", textColor: "highlight.700" },
      _disabled: { borderColor: "body.500", textColor: "body.500" },
    },
    destructive: {
      ...extendedStyles,
      borderColor: "tiles.300",
      bg: "notifications.100",
      textColor: "body.100",
      _hover: {
        bg: "tiles.300",
        borderColor: "tiles.300",
        _disabled: { bg: "body.500", borderColor: "body.500" },
      },
      _active: { bg: "notifications.700", borderColor: "tiles.300", },
      _focus: { bg: "notifications.700", borderColor: "tiles.300", },
      _disabled: { bg: "body.500", borderColor: "body.500" },
    },
    ghost: {
      ...baseStyles,
      border: "none",
      textColor: "highlight.600",
      fontWeight: "medium",
      _hover: {
        bg: "none",
        textDecoration: "underline",
        textColor: "highlight.400",
        _disabled: { textColor: "body.500", textDecoration: "none", },
      },
      _active: { textColor: "highlight.700" },
      _focus: { textColor: "highlight.700" },
      _disabled: { textColor: "body.500" },

    },
    ghostIcon: {
      ...baseStyles,
      padding: 0,
      //bg: "transparent",
      border: "none",
      textColor: "highlight.600",
      fontWeight: "medium",
      _hover: {
        bg: "body.200",
        textDecoration: "underline",
        textColor: "highlight.400",
        _disabled: { textColor: "body.500", textDecoration: "none", },
      },
      _active: { textColor: "highlight.700" },
      _focus: { textColor: "highlight.700" },
      _disabled: { textColor: "body.500" },

    },
    icon: {
      padding: 0,
      bg: "transparent",
      _focus: { bg: "transparent" },
      _active: { bg: "transparent" },
      _hover: { bg: "transparent" }
    },
    headerAction: {
      ...baseStyles,
      borderRadius: "10px",
      height: "35px",
      bg: "nav.background",
      color: "body.100",
      border: "none",
      fontWeight: "normal",
      _hover: { bg: "nav.background", opacity: 0.85, _disabled: { bg: "body.500" } },
      _active: { bg: "nav.background" },
      _focus: { bg: "nav.background" },
      _disabled: { bg: "body.500" },
    }
  },
};

export { Button };
